import React, { useState, useEffect } from "react";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import axios from "axios"; // Import axios
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2"; // Import SweetAlert2

function SocialMedia() {
  const [facebookUrl, setFacebookUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [whatsappUrl, setWhatsappUrl] = useState("");

  // Fetch the social media details from the API
  const fetchSocialMediaDetails = async () => {
    try {
      const response = await axios.get(`${baseurl}/getSocialMediaDetails`);
      if (response.status === 200 && response.data.data) {
        const { facebook_url, twitter_url, instagram_url, linkedin_url, whatsapp_url } = response.data.data;
        // Set the state with the fetched values
        setFacebookUrl(facebook_url || "");
        setTwitterUrl(twitter_url || "");
        setInstagramUrl(instagram_url || "");
        setLinkedinUrl(linkedin_url || "");
        setWhatsappUrl(whatsapp_url || "");
      } else {
        console.error("Failed to fetch social media details");
      }
    } catch (error) {
      console.error("Error fetching social media details:", error);
    }
  };

  useEffect(() => {
    fetchSocialMediaDetails(); // Fetch the social media details when the component mounts
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create the payload to send to the backend
    const payload = {
      facebookUrl,
      twitterUrl,
      instagramUrl,
      linkedinUrl,
      whatsappUrl,
    };

    try {
      const response = await axios.post(`${baseurl}/social-media`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        // SweetAlert2 for success
        Swal.fire({
          icon: 'success',
          title: 'Social media links updated successfully!',
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        // Handle error response
        Swal.fire({
          icon: 'error',
          title: 'Error updating social media links',
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      // SweetAlert2 for network error
      Swal.fire({
        icon: 'error',
        title: 'Network error',
        text: 'Please try again later.',
      });
    }
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />
        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Social Media Links</h2>
                  <div className="ms-auto"></div>
                </div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    {/* Social Media Form */}
                    <div className="">
                      <form onSubmit={handleSubmit}>
                        <div className="row g-1 text-start">
                          <div className="col-md-9 rtqq1">
                            <div className="row g-1">
                              {/* Facebook */}
                              <div className="col-md-12">
                                <label className="text-dark mb-1 labelset2 font3">Facebook URL</label>
                                <input
                                  type="url"
                                  className="input1"
                                  placeholder="Enter Facebook URL"
                                  value={facebookUrl}
                                  onChange={(e) => setFacebookUrl(e.target.value)}
                                />
                              </div>

                              {/* Twitter/X */}
                              <div className="col-md-12">
                                <label className="text-dark mb-1 labelset2 font3">Twitter/X URL</label>
                                <input
                                  type="url"
                                  className="input1"
                                  placeholder="Enter Twitter/X URL"
                                  value={twitterUrl}
                                  onChange={(e) => setTwitterUrl(e.target.value)}
                                />
                              </div>

                              {/* Instagram */}
                              <div className="col-md-12">
                                <label className="text-dark mb-1 labelset2 font3">Instagram URL</label>
                                <input
                                  type="url"
                                  className="input1"
                                  placeholder="Enter Instagram URL"
                                  value={instagramUrl}
                                  onChange={(e) => setInstagramUrl(e.target.value)}
                                />
                              </div>

                              {/* LinkedIn */}
                              <div className="col-md-12">
                                <label className="text-dark mb-1 labelset2 font3">LinkedIn URL</label>
                                <input
                                  type="url"
                                  className="input1"
                                  placeholder="Enter LinkedIn URL"
                                  value={linkedinUrl}
                                  onChange={(e) => setLinkedinUrl(e.target.value)}
                                />
                              </div>

                              {/* WhatsApp */}
                              <div className="col-md-12">
                                <label className="text-dark mb-1 labelset2 font3">WhatsApp Number/URL</label>
                                <input
                                  type="url"
                                  className="input1"
                                  placeholder="Enter WhatsApp URL (e.g., https://wa.me/1234567890)"
                                  value={whatsappUrl}
                                  onChange={(e) => setWhatsappUrl(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="text-end">
                          <button type="submit" className="submit-btn mt-3">
                            Save Changes
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SocialMedia;
